"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var exchangeState_1 = require("../states/exchangeState");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var exchangeService_1 = require("../services/exchangeService");
var authSelectors_1 = require("../selectors/authSelectors");
var exchangeSelectors_1 = require("../selectors/exchangeSelectors");
var utils_1 = require("../helper/utils");
var authState_1 = require("../states/authState");
function fetchAppointmentsEffect(action) {
    var token, data, e_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.fetchAppointmentService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getAppointmentsSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getAppointmentsFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchAppointmentsEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function bookAppointmentsEffect(action) {
    var token, _a, sectionsubscriptionid_1, bookingMode, appointmentToBook, workExecutionId, language, responseStatus, unknownErrorMsg, error_1, language, responseStatus, conflictErrorMsg, errorMsg;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 10, , 17]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _c.sent();
                _a = action.payload, sectionsubscriptionid_1 = _a.sectionsubscriptionid, bookingMode = _a.bookingMode;
                return [4 /*yield*/, (0, effects_1.select)(function (state) { return (0, exchangeSelectors_1.getAppointmentToBook)(state, sectionsubscriptionid_1); })];
            case 2:
                appointmentToBook = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(exchangeSelectors_1.getWorkExectionId)];
            case 3:
                workExecutionId = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_c.sent()).language;
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(bookingMode === 'create'
                        ? exchangeService_1.bookAppointmentService
                        : exchangeService_1.updateAppointmentService, workExecutionId, appointmentToBook, token)];
            case 5:
                responseStatus = _c.sent();
                if (!(responseStatus === 204)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.bookAppointmentSuccess('success'))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7:
                unknownErrorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.bookAppointmentFailure('failure', unknownErrorMsg))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [3 /*break*/, 17];
            case 10:
                error_1 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 11:
                language = (_c.sent()).language;
                responseStatus = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.status;
                if (!(responseStatus === 409)) return [3 /*break*/, 13];
                conflictErrorMsg = (0, i18n_1.default)(language).exchanges.appointment.conflict;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.bookAppointmentFailure('conflict', conflictErrorMsg))];
            case 12:
                _c.sent();
                return [3 /*break*/, 15];
            case 13:
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.bookAppointmentFailure('failure', errorMsg))];
            case 14:
                _c.sent();
                _c.label = 15;
            case 15: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, bookAppointmentsEffect.name))];
            case 16:
                _c.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function cancelAppointmentsEffect(action) {
    var token, workExecutionId, language, responseStatus, unknownErrorMsg, error_2, language, responseStatus, conflictErrorMsg, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 8, , 15]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                workExecutionId = action.payload;
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 2:
                language = (_b.sent()).language;
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.cancelAppointmentService, workExecutionId, token)];
            case 3:
                responseStatus = _b.sent();
                if (!(responseStatus === 204)) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.cancelAppointmentSuccess('success'))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownErrorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.cancelAppointmentFailure('failure', unknownErrorMsg))];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [3 /*break*/, 15];
            case 8:
                error_2 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 9:
                language = (_b.sent()).language;
                responseStatus = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.status;
                if (!(responseStatus === 409)) return [3 /*break*/, 11];
                conflictErrorMsg = (0, i18n_1.default)(language).exchanges.appointment.conflict;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.cancelAppointmentFailure('conflict', conflictErrorMsg))];
            case 10:
                _b.sent();
                return [3 /*break*/, 13];
            case 11:
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.cancelAppointmentFailure('failure', errorMsg))];
            case 12:
                _b.sent();
                _b.label = 13;
            case 13: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, cancelAppointmentsEffect.name))];
            case 14:
                _b.sent();
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}
function getRequestsEffect(action) {
    var token, data, e_2, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.getClientRequestsService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getClientRequestsSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getClientRequestsFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getRequestsEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getRequestsEligibilityEffect(action) {
    var token, data, e_3, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.getClientEligibilityRequestsService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getClientRequestsEligibilitySuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getClientRequestsEligibilityFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getRequestsEligibilityEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getAlertsMultiRecipientsEffect(action) {
    var token, data, e_4, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.getRecipientsInformationsService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getAlertsMultiRecipientsSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_4 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.getAlertsMultiRecipientsFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getAlertsMultiRecipientsEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateAlertsRecipientsEffect(action) {
    var token, response, e_5, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 14]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.updateAlertsRecipientsService, action.payload.clientId, action.payload.sectionSubscriptionId, action.payload.contacts, token, action.payload.origin)];
            case 2:
                response = _a.sent();
                if (!(response.status === 204)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.updateRecipientsAlertSuccess('success', null))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                if (!(response.status === 200)) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.updateRecipientsAlertSuccess('successWithErrors', response.data))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 14];
            case 7:
                e_5 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_5)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.updateRecipientsAlertFailure('failure', errorMsg))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateAlertsRecipientsEffect.name))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function validateAlertContactEffect(action) {
    var responseStatus, language, unknownErrorMsg, e_6, language, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 7, , 11]);
                return [4 /*yield*/, (0, effects_1.call)(exchangeService_1.validateAlertContactService, action.payload)];
            case 1:
                responseStatus = _c.sent();
                if (!(responseStatus === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.validateAlertContactSuccess('success'))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_c.sent()).language;
                unknownErrorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.validateAlertContactFailure('failure', unknownErrorMsg, responseStatus))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [3 /*break*/, 11];
            case 7:
                e_6 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_6 === null || e_6 === void 0 ? void 0 : e_6.response) === null || _a === void 0 ? void 0 : _a.status) === 409) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.alreadyValidated;
                }
                return [4 /*yield*/, (0, effects_1.put)(exchangeState_1.exchangeAction.validateAlertContactFailure('failure', errorMsg, (_b = e_6 === null || e_6 === void 0 ? void 0 : e_6.response) === null || _b === void 0 ? void 0 : _b.status))];
            case 9:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, validateAlertContactEffect.name))];
            case 10:
                _c.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function exchangeEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.getAppointments.type, fetchAppointmentsEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.bookAppointment.type, bookAppointmentsEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.cancelAppointment.type, cancelAppointmentsEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.getClientRequests.type, getRequestsEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.getClientRequestsEligibility.type, getRequestsEligibilityEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.getAlertsMultiRecipients.type, getAlertsMultiRecipientsEffect)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.updateRecipientsAlert.type, updateAlertsRecipientsEffect)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(exchangeState_1.exchangeAction.validateAlertContact.type, validateAlertContactEffect)];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = exchangeEffects;
